import { type ReactNode } from 'react';

import { Sidebar } from './Sidebar';
import { SuiteNavbar } from './SuiteNavbar';
import { TrialBanner } from './TrialBanner';

type AppShellProps = {
  children: ReactNode;
};

export function AppShell({ children }: AppShellProps) {
  return (
    <div className="min-h-screen flex flex-col bg-bg">
      <SuiteNavbar />
      <TrialBanner />
      <div className="flex flex-1 min-h-0">
        <Sidebar />
        <main className="flex-1 min-w-0 p-7 w-full">{children}</main>
      </div>
    </div>
  );
}
